import React from 'react'
import PropTypes from 'prop-types'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Deal.style'
import { Box, Typography } from '@mui/material'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import {
  CheckboxStyle,
  FormControlLabelStyle,
  Label
} from '../../../../components/styled/global.style'
import {
  ButtonGroupStyle,
  OptionContainer,
  OptionCounterparty,
  PutCallButton,
  SideButton
} from '../../Deal.style'
import FlagCurrency from '../../../../components/FlagCurrency/FlagCurrency'
import CurrencyLogo from '../../../../components/CurrencyLogo/CurrencyLogo'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

const VanillaDealMarketMakerSide = ({
  marketMakers,
  sides,
  putCall,
  cut,
  fixingSource,
  currencyData,
  currencyInitial,
  disabledField,
  handelDateChange,
  form,
  errors,
  handelFormChange,
  handelFocusCurrencyPair,
  handelBlurCurrencyPair,
  children,
  checkPrimeBrokerIsRBS,
  tradingAccountTradersNormalize
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Trade Type *</Label>
        <InputBaseStyle value={`Market ${form.deal_type.name}`} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Trade Date *</Label>
        <TextFieldStyle type="datetime-local" value={form.trade_date} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Market Maker *</Label>
        {Array.isArray(marketMakers.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'market_maker'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.market_maker}
            options={marketMakers.data.map(({ name }) => name)}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder={'Select Market Maker'} />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Client Side *</Label>
        {Array.isArray(sides.data) && (
          <ButtonGroupStyle variant="outlined">
            {sides.data.map(({ name }, id) => (
              <SideButton
                name="client_side"
                key={id}
                disabled={form.client_side !== name}
                value={name}
                select={String(form.client_side === name)}
              >
                {name}
              </SideButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Put/Call *</Label>
        {Array.isArray(putCall) && (
          <ButtonGroupStyle variant="outlined">
            {putCall.map(({ name }, id) => (
              <PutCallButton
                name="put_call"
                key={id}
                value={name}
                disabled={disabledField.put_call || form.put_call !== name}
                select={String(form.put_call === name)}
              >
                {name}
              </PutCallButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Currency Pair *</Label>
        <InputBaseStyle
          value={form.currency_pair}
          name="currency_pair"
          onChange={handelFormChange}
          onFocus={handelFocusCurrencyPair}
          onBlur={handelBlurCurrencyPair}
          error={errors.currency_pair}
        />
        {errors.currency_pair !== '' && <FormError>{errors.currency_pair}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Expiry Date *</Label>
        <TextFieldStyle
          type="date"
          disabled
          variant="outlined"
          value={form.expiry}
          onChange={event => handelDateChange('expiry', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Quantity *</Label>
        <InputBaseStyle
          disabled={true}
          value={form.quantity}
          name="quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Strike Price *</Label>
        <InputBaseStyle
          disabled
          value={form.strike}
          name="strike"
          onChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>

      <Box width={'100%'}>
        <Label>Cut *</Label>
        {Array.isArray(cut.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'cut'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            disabled
            size={'small'}
            value={form.cut}
            options={cut.data.map(({ cut }) => cut)}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder="Select Cut" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Settlement Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          disabled
          value={form.settlement_date}
          onChange={event => handelDateChange('settlement_date', event.target.value)}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Fixing Source </Label>
        {Array.isArray(fixingSource.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'fixing_source'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            disabled
            value={form.fixing_source}
            options={fixingSource.data.map(({ name }) => name)}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder="Select Fix Source" disabled />
            )}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>

      {Array.isArray(currencyData.data) && (
        <Box width={'100%'}>
          <Label>Premium Currency *</Label>
          <AutocompleteStyle
            fullWidth
            onChange={(event, element) => {
              event.target.name = 'market_maker_premium_currency'
              element = element ?? currencyInitial
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.market_maker_premium_currency}
            getOptionLabel={option => option.name}
            options={currencyData.data}
            renderOption={(props, option) => (
              <OptionContainer {...props} key={option.id}>
                <FlagCurrency countryCode={option.code3} />
                <CurrencyLogo currencyCode={option.name} />
                <Typography>{option.name} </Typography>
              </OptionContainer>
            )}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder="Select Currency" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        </Box>
      )}

      <Box width={'100%'}>
        <Label>Premium Amount*</Label>
        <InputBaseStyle
          value={form.market_maker_premium_amount}
          name="market_maker_premium_amount"
          onChange={handelFormChange}
          placeholder="0.00"
        />
      </Box>

      <Box width={'100%'}>
        <Label>Premium Date *</Label>
        <TextFieldStyle
          type="date"
          variant="outlined"
          value={form.market_maker_premium_date}
          onChange={event => handelDateChange('market_maker_premium_date', event.target.value)}
        />
      </Box>

      <Box width={'100%'}>
        <Label>Trader </Label>
        {tradingAccountTradersNormalize.status === 200 && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'market_maker_trader_name'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.market_maker_trader_name}
            getOptionLabel={option => option}
            disabled={
              form.market_maker === '' ||
              !Array.isArray(tradingAccountTradersNormalize.data[form.market_maker]) ||
              tradingAccountTradersNormalize.data[form.market_maker].length === 0
            }
            options={
              form.market_maker !== '' &&
              Array.isArray(tradingAccountTradersNormalize.data[form.market_maker])
                ? tradingAccountTradersNormalize.data[form.market_maker].map(
                    trader_name => trader_name
                  )
                : []
            }
            renderInput={params => (
              <TextFieldModalStyle {...params} fullWidth placeholder="Select Trader" />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Market Note</Label>
        <InputBaseStyle
          value={form.market_maker_note}
          name="market_maker_note"
          onChange={handelFormChange}
        />
      </Box>
      {children}
      {checkPrimeBrokerIsRBS && (
        <>
          <Box width={'100%'}>
            <Label>Bdr</Label>
            <InputBaseStyle value={form.bdr} name="bdr" onChange={handelFormChange} />
          </Box>
          <Box
            style={{
              display: 'flex',
              margin: 'inherit'
            }}
          >
            <FormControlLabelStyle
              onChange={handelFormChange}
              name="is_pba"
              style={{ color: 'white' }}
              control={
                <CheckboxStyle
                  style={{ marginRight: '8px' }}
                  checked={form.is_pba}
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                />
              }
              label="PBA"
            />
            <FormControlLabelStyle
              onChange={handelFormChange}
              name="is_structure"
              style={{ color: 'white' }}
              control={
                <CheckboxStyle
                  style={{ margin: '0px 8px' }}
                  checked={form.is_structure}
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                />
              }
              label="Structure"
            />
          </Box>
        </>
      )}
    </>
  )
}

export default VanillaDealMarketMakerSide

VanillaDealMarketMakerSide.propTypes = {
  marketMakers: PropTypes.object,
  sides: PropTypes.object,
  putCall: PropTypes.array,
  cut: PropTypes.object,
  fixingSource: PropTypes.object,
  currencyData: PropTypes.object,
  tradingAccountTradersNormalize: PropTypes.object,
  disabledField: PropTypes.object,
  currencyInitial: PropTypes.object,
  traders: PropTypes.object,
  handelFormChange: PropTypes.func,
  handelDateChange: PropTypes.func,
  handelFocusCurrencyPair: PropTypes.func,
  handelBlurCurrencyPair: PropTypes.func,
  checkPrimeBrokerIsRBS: PropTypes.bool,
  form: PropTypes.object,
  errors: PropTypes.object,
  children: PropTypes.node
}
